import PromptHeader from '../components/PromptHeader.jsx';
import {useEffect, useRef, useState} from "react";
import {db} from "../db";
import CollectionImage from "../components/CollectionImage";
import {useGenerateDispatch, useGenerateStatus} from "../context/GenerateContext";
import {accountNosignin, cancelJob, generateOutput, generatePrompt, getCollectionHashes, getCollectionImage, getProgress, updateAccount, setReceived, getUndeliveredImages, getTokens} from "../api-helper";
import {getGenerateOutput} from "../api-helper";
import md5 from "blueimp-md5"
import DrawingInput from "../components/inputs/DrawingInput";
import CloseIcon from "../images/icons/white-close.svg";
import DoubleRightIcon from "../images/icons/white-double-right.svg";
import DoubleLeftIcon from "../images/icons/white-double-left.svg";
import GreyDoubleRightIcon from "../images/icons/grey-double-right.svg";
import GreyDoubleLeftIcon from "../images/icons/grey-double-left.svg";
import {usePromptusAPIState} from "../context/PromptusAPIContext";
import { useAccountContext, useAccountContextDispatch } from '../context/AccountContext.js';
import Swal from 'sweetalert2';
import { useCollectionContext, useCollectionContextDispatch } from '../context/CollectionContext.js';
import { isUndefined } from 'cropperjs';
import LazyLoad from 'react-lazyload';
import { VariableSizeGrid as Grid } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';


export const defaultPrompt = {
    accountNo: "",
    error: "",
    progress: 0,
    prompt: {
        prompt: "",
        negative_prompt: "",
        enhanced: false,
        prompt_output: "text-image",
        audio_prompt: "",
        input_language: "en",
        meme_prompt: false,
        params: {
            seed_value: "",
            num_inference_steps: 12,
            guidance_scale: 7.5,
            scheduler: "DPM-Solver",
            model: "stable-diffusion-v1-5",
            lora: "None",
            lora_scale: 0,
            width: 512,
            height: 512,
            count: 1,
            symmetric: false,
            shuffle: false,
            safety_checker: true,
            input_image: null,
            tile: false,
            upscale: false,
            upscale_factor: 0,
            control_net: "",
            mask_image: null,
            full_precision: false,
            half_model: false,
            cpu_generation: false,
            cpu_offloading: false,
            image_batch_size: 1
        }
    }
};


function Placeholder(props){
    const generateStatus = useGenerateStatus();
    if (props.Count >= 1) {
        const renderPlaceholders = () => {
            let NumberOfPlaceholders;
            let placeholder; 
            for (let i = 0; i < props.Count; i++) {
                placeholder =
                <div className={"group w-full rounded-xl overflow-hidden relative bg-gray-400 animate-pulse"}>
                    <img className={"w-full"} src="https://i.postimg.cc/632gRsSp/Final-logo-Black.png" alt='Help'/>
                </div>;
            };
            return [].concat(...Array(props.Count).fill(placeholder));
          };  
          return renderPlaceholders()
    }
}
  

export default function Generate() {
    const generateStatusDispatch = useGenerateDispatch();
    const generateStatus = useGenerateStatus();
    const accountContextDispatch = useAccountContextDispatch();
    const accountContext = useAccountContext();
    const apiState = usePromptusAPIState();
    const [imageList, setImageList] = useState([]);
    const [columnClass, setColumnClass] = useState("cols-4");
    const [zoomedImage, setZoomedImage] = useState(null);
    const [loadingImages, setLoadingImages] = useState(false);
    const [localDirectory, setLocalDirectory] = useState("");
    const [redoPromptUid, setRedoPromptUid] = useState("");
    const [redoPrompt, setRedoPrompt] = useState("");
    const [redoSeed, setRedoSeed] = useState("");
    const [inputImage, setInputImage] = useState({});
    const [category, setCategory] = useState("All");
    const [categories, setCategories] = useState([]);
    const [categories2, setCategories2] = useState([]);
    const collectionContextDispatch = useCollectionContextDispatch();
    const collectionContext = useCollectionContext();
    const [showAll, setShowAll] = useState(false);
    const [empty, setEmpty] = useState(false);
    const [page, setPage] = useState(0);
    const [totalStoredImages, setTotalStoredImages] = useState(0);
    const [unfinished, setUnfinished] = useState([]);
    const [onlineImages, setOnlineImages] = useState([]);
    const [account, setAccount] = useState({});
    const [sortMethod, setSortMethod] = useState("Newest");
    const [failedImage, setFailedImage] = useState(false);
    const [failedImageID, setFailedImageID] = useState("");
    const [viewFailedImage, setViewFailedImage] = useState(false);
    const [failedImageDetails, setFailedImageDetails] = useState({});
    const [isFetching, setIsFetching] = useState(false);
    const [seconds, setSeconds] = useState(0);
    const [startTimer, setStartTimer] = useState(false);
    const [sameSeed, setSameSeed] = useState(false);
    const [fetchingUndelivered, setFetchingUndelivered] = useState(false);
    const [sameSeedDate, setSameSeedDate] = useState(0);
    const [queryBusy, setQueryBusy] = useState(false);
    
    const columnCount = 4;
    const gap = 16;
    const columnWidth = 200 + gap;
    const rowHeight = 250 + gap;
    const width = 800;
    const rowCount = Math.ceil(imageList.length / columnCount);
    const height = 600;


    const populateHistory = async () => {
        await db.transaction('rw', db.history, async () => {
            await db.history.clear();
        })
        const promptMap = new Map();
    
        // Function to process prompts and seeds from a table
        const processPromptsAndSeeds = async () => {
            await db.collection.each(record => {
                let prompt, seed;
                
                if (record.prompt) {
                    if (typeof record.prompt === 'object' && record.prompt.prompt && record.prompt.prompt.prompt) {
                        prompt = record.prompt.prompt.prompt;
                    } else if (typeof record.prompt === 'string') {
                        prompt = record.prompt;
                    }
                }
    
                seed = record.seed;
                if (prompt) {
                    if (!promptMap.has(prompt)) {
                        promptMap.set(prompt, new Set());
                    }
                    if (seed) {
                        promptMap.get(prompt).add(seed);
                    }
                }
            });
        };
    
        // Get existing prompts from history
        const existingPrompts = new Set(await db.history.toCollection().primaryKeys());
    
        // Process prompts and seeds from both tables
        await processPromptsAndSeeds();
    
        // Filter out existing prompts
        const newPrompts = Array.from(promptMap.keys()).filter(prompt => !existingPrompts.has(prompt));

    
        if (newPrompts.length > 0) {
            // Add new prompts with their seeds to history
            await db.history.bulkAdd(newPrompts.map(prompt => ({
                prompt,
                seeds: Array.from(promptMap.get(prompt))
            })));
    
            console.log(`Added ${newPrompts.length} new prompts to history`);
        } else {
            console.log('No new prompts to add to history');
        }
    };

    /**
     * Get the user ID
     * @returns {Promise<*>}
     */
    const getUUID = async () => {
        return accountContext.accountDetails.accountNo
    }

    /**
     * Sends the prompt to the API stores it in the global state
     * @param prompt
     */
    const handleGenerate = (prompt, failedImage, failedImageID) => {
        console.log("Is it a failed image regen? ",failedImage);
        console.log("The failed image ID ", failedImageID);
        setFailedImage(failedImage);
        setFailedImageID(failedImageID);
        getUUID().then(UUID => {
            prompt.accountNo = UUID;
            if (prompt.prompt.params.seed_value === "") {
                setSameSeed(false);
            } else {
                setSameSeed(true);
            }
            generatePrompt(prompt, apiState, generateStatusDispatch)
                .then(data => {
                    setRedoPromptUid("");
                    if (data.error) {
                        generateStatusDispatch({
                            type: 'error',
                            message: data.error
                        });
                    }
                    if (data.uid) {
                        db.collection.add({
                            uid: data.uid,
                            prompt,
                            queue: data.queues,
                            timestamp: Date.now(),
                        }).then(() => {
                            localStorage.setItem('isCancelling', false);
                            if (failedImage) {
                                generateStatusDispatch({type: 'failedImage'})
                            }
                            setSameSeedDate(Date.now());
                            generateStatusDispatch({type: 'generate', uid: data.uid, count: prompt.prompt.params.count});
                            localStorage.setItem('remember_workload', JSON.stringify({
                                active: true,
                                uid: data.uid,
                                count: prompt.prompt.params.count,
                                totalImage: 0,
                                num: 0,
                            }))
                        });
                    }
            });
        });
    }

    const findFailedMatches = (failedImages, undeliveredImages) => {
        console.log("Looking for failed matches to deliver");
        
        return undeliveredImages.filter(largeItem => 
            failedImages.some(smallItem => smallItem.uid === largeItem.jobUid)
        );
      };

    const removeFailedMatches = (failedImages, undeliveredImages) => {
        console.log("Removing failed matches from undelivered images");
        
        return undeliveredImages.filter(largeItem => 
            !failedImages.some(smallItem => smallItem.uid === largeItem.jobUid)
        );
    };  

    const checkingUndeliveredImages = async () => {
        console.log("Checking if a workload was active");
        if (fetchingUndelivered) return;

        console.log("Checking for undelivered images");
        console.log("API State: ", apiState);
    
        const autoRecovery = await db.settings.where('key').equals('auto_recovery').first(setting => {
            return setting.value;
        });
    
        if (apiState.online == true && autoRecovery) {
            console.log("Auto Recovery is enabled, checking for undelivered images");
    
            let moreUndeliveredImages = true; // Flag to indicate if there are more undelivered images to fetch
    
            while (moreUndeliveredImages) {
                await getUndeliveredImages(accountContext.accountDetails.accountNo).then(async(data) => {
                    if (data) {
                        setFetchingUndelivered(true);
                        console.log("Undelivered Images: ", data);
        
                        // Filter out any empty job UIDs
                        const undeliveredUids = data.filter(uid => uid.jobUid !== "");
                        console.log("Undelivered Images Filtered: ", undeliveredUids);
        
                        // If no new undelivered images are found, stop the loop
                        if (undeliveredUids.length === 0) {
                            console.log("No more undelivered images found, stopping process");
                            moreUndeliveredImages = false;
                            return;
                        }
        
                        generateStatusDispatch({ type: 'undeliveredImages' });
                        generateStatusDispatch({ type: 'totalUndeliveredImages', totalUndeliveredImages: undeliveredUids.length });
        
                        // Handle failed images from the database
                        const undeliveredFailedImages = await db.images.filter(image => image.image === "" && image.online).toArray();
                        const uniqueArray = undeliveredFailedImages.reduce((acc, item) => {
                            if (!acc.some(existingItem => existingItem.uid === item.uid)) {
                                acc.push(item);
                            }
                            return acc;
                        }, []);
                        console.log("Undelivered Failed Images: ", uniqueArray);
        
                        const failedMatches = findFailedMatches(uniqueArray, undeliveredUids);
                        console.log("Found undelivered images: ", failedMatches);
        
                        if (failedMatches.length > 0) {
                            for (const undeliveredFailedImage of failedMatches) {
                                generateStatusDispatch({ type: 'checkingUndeliveredImages' });
                                console.log("Undelivered Image: ", undeliveredFailedImage.uid);
                                const results = await db.images.where('uid').equals(undeliveredFailedImage.jobUid).and(item => item.image === '').toArray();
                                if (results.length > 0) {
                                    console.log("Results: ", results[0]);
                                    console.log("Output UID: ", undeliveredFailedImage.uid);
                                    const hashcheck = await db.images.where('hash').equals(undeliveredFailedImage.uid).first();
                                    const image = await getGenerateOutput(undeliveredFailedImage.jobUid, undeliveredFailedImage.uid);
                                    const imageCheck = await db.images.where('image').equals(image.image).first();
                                    if (!hashcheck && !imageCheck) {
                                        generateStatusDispatch({ type: 'retrievingUndeliveredImages' });
                                        await db.images.update(results[0].id, {
                                            image: image.image,
                                            seed: image.seed,
                                            model: image.model ?? '',
                                            hash: undeliveredFailedImage.uid,
                                            prompt: image.prompt,
                                            receivedtimestamp: Date.now()
                                        });
                                        generateStatusDispatch({ type: 'totalRetrievedImages' });
                                        refreshImages();
                                        console.log("Image uid ", undeliveredFailedImage.uid, "returned image: ", image);
                                    }
                                    setReceived(undeliveredFailedImage.jobUid, undeliveredFailedImage.uid);
                                }
                            }
                        }
        
                        const remainingImages = removeFailedMatches(uniqueArray, undeliveredUids);
                        console.log("Remaining Images: ", remainingImages);
        
                        if (remainingImages.length > 0) {
                            console.log("There are undelivered images that are not failed images");
                            if (remainingImages.length > 50) {
                                Swal.fire({
                                    color: "#190A4E",
                                    title: `You have ${remainingImages.length} undelivered images. This is a large amount of image and it might take some time so please be patient.`,
                                    icon: "info",
                                    showConfirmButton: false,
                                    showCancelButton: false,
                                    timer: 2000
                                });
                            }
        
                            await Promise.all(
                                remainingImages.map(async (undeliveredImage) => {
                                    generateStatusDispatch({ type: 'checkingUndeliveredImages' });
                                    console.log("Undelivered Image: ", undeliveredImage.uid);
                                    const hashcheck = await db.images.where('hash').equals(undeliveredImage.uid).first();
                                    const image = await getGenerateOutput(undeliveredImage.jobUid, undeliveredImage.uid);
                                    const imageCheck = await db.images.where('image').equals(image.image).first();
                                    if (!hashcheck && !imageCheck) {
                                        generateStatusDispatch({ type: 'retrievingUndeliveredImages' });
                                        await db.images.put({
                                            image: image.image,
                                            seed: image.seed,
                                            uid: undeliveredImage.jobUid,
                                            model: image.model ?? '',
                                            inCollection: false,
                                            hash: undeliveredImage.uid,
                                            online: apiState.online,
                                            tag: "",
                                            prompt: image.prompt,
                                            receivedtimestamp: Date.now(),
                                            requestedtimestamp: Date.now()
                                        });
                                        generateStatusDispatch({ type: 'totalRetrievedImages' });
                                        refreshImages();
                                        console.log("Image uid ", undeliveredImage.uid, "returned image: ", image);
                                    }
                                    setReceived(undeliveredImage.jobUid, undeliveredImage.uid);
                                })
                            );
                        }
                    }
                });
                // console.log("END OF THE WHILE LOOP");
                // console.log("Cancel Check: ", generateStatus.cancellingUndeliveredCheck);
                
                // if (generateStatus.cancellingUndeliveredCheck == true) {
                //     console.log("Cancelling the while loop");
                //     generateStatusDispatch({ type: 'resetcancellingUndeliveredCheck' })
                //     break;
                // }
            }
        }
        generateStatusDispatch({ type: 'done' });
        setFetchingUndelivered(false);
    };
    

    useEffect(() => {
        if (apiState.host !== "" && apiState.host.includes("api")) {
            checkingUndeliveredImages();
        }
    }, [apiState.host])

    /**
     * Get the total stored images from the database
     * @returns {Promise<void>}
     */
    const getTotalStoredImages = async () => {
        setLoadingImages(true);
        await db.images.count().then(count => setTotalStoredImages(count)).then(() => {
            // When the generate page loads fetch your images
            refreshImages().then(() => setLoadingImages(false));
        });
    }

    /**
     * Refresh the images and action the pagination
     * @returns {Promise<void>}
     */
    // const refreshImages = async () => {
    //     let playgroundImages = await db.images.reverse().toArray();
    //     if (!showAll) {
    //         await db.images.reverse().offset(page * 20).limit(20).toArray((images) => setImageList(images));
    //     } else {
    //         await db.images.reverse().toArray((images) => setImageList(images));
    //     }
    
    //     if (category !== "All") {
    //         if (category === "Public" || category === "Private") {
    //             playgroundImages = playgroundImages.filter(image => image.public === (category === "Public"));
    //         } else if (category === "Non-Tagged") {
    //             playgroundImages = playgroundImages.filter(image => isUndefined(image.tag) || image.tag === "");
    //         } else {
    //             playgroundImages = playgroundImages.filter(image => !isUndefined(image.tag) && image.tag.toLowerCase().includes(category.toLowerCase()));
    //         }
    //         const startIndex = page * 20;
    //         const endIndex = startIndex + 20;
    //         const slicedImages = playgroundImages.slice(startIndex, endIndex);
        
    //         setImageList(slicedImages);
    //     }
    // }

    const refreshImages = async () => {
        if (queryBusy) return;

        console.log("Refreshing Images");

        setQueryBusy(true);
        let query = db.images;
    
        // Apply category filters
        
        // Apply sorting
        switch(sortMethod) {
            case "Newest":
                query = query.orderBy('receivedtimestamp').reverse();
                break;
            case "Oldest":
                query = query.orderBy('receivedtimestamp');
                break;
            case "New_requested":
                query = query.orderBy('requestedtimestamp').reverse();
                break;
            case "Old_requested":
                query = query.orderBy('requestedtimestamp');
                break;
            case "Non-Tagged-Asc":
            case "Non-Tagged-Desc":
                query = query.where('tag').equals(undefined).or('tag').equals("");
                if (sortMethod === "Non-Tagged-Asc") query = query.reverse();
                break;
            case "AIHorde-Images-Asc":
            case "AIHorde-Images-Desc":
                query = query.where('model').startsWithIgnoreCase('AI-Horde');
                if (sortMethod === "AIHorde-Images-Asc") query = query.reverse();
                break;
        }

        // Apply category filters
        if (category !== "All") {
            if (category === "Non-Tagged") {
                query = query.filter(image => !image.tag || image.tag === "");
            } else if (category === "Failed") {
                query = query.filter(image => image.image === "");
            } else {
                query = query.filter(image => image.tag && image.tag.toLowerCase().includes(category.toLowerCase()));
            }
        }
    
        // Apply pagination
        if (!showAll) {
            query = query.offset(page * 20).limit(20);

                    // Execute query and update state
            const playgroundImages = await query.toArray();
            setImageList(playgroundImages);
        } else {
            const batchSize = 250;
            let allImages = [];
            let count = 0;

            await query.each(image => {
                allImages.push(image);
                count++;

                if (count % batchSize === 0) {
                    setImageList([...allImages]); // Update state with current batch
                    // Allow UI to update
                    return new Promise(resolve => setTimeout(resolve, 0));
                }
            });

            // Final update with all images
            setImageList(allImages);
        }
        
        // console.log("Playground Images: ", playgroundImages);
        setQueryBusy(false);
    }

    // const Cell = ({ columnIndex, rowIndex, style, data }) => {
    //     const { imageList, columnCount, gap } = data;
    //     const index = rowIndex * columnCount + columnIndex;
    //     const image = imageList[index];
    
    //     // Adjust style for gaps
    //     const adjustedStyle = {
    //       ...style,
    //       width: style.width - gap,
    //       height: style.height - gap,
    //       left: style.left + gap / 2,
    //       top: style.top + gap / 2,
    //     };
    
    //     if (!image) {
    //       return generateStatus.loading && !generateStatus.failedImage ? (
    //         <div style={adjustedStyle} className="image-cell">
    //           <Placeholder Count={1} />
    //         </div>
    //       ) : null;
    //     }
    
    //     return (
    //       <div style={adjustedStyle} className="image-cell">
    //         <CollectionImage
    //           {...image}
    //           key={`image_${index}_${image.id}`}
    //           refreshImages={getTotalStoredImages}
    //           setZoomedImage={(image) => setZoomedImage(image)}
    //           setUid={(uid) => handleRedos(null,null,uid)}
    //           setPrompt={(prompt) => handleRedos(prompt,null,null)}
    //           setSeed={(seed) => handleRedos(null,seed,null)}
    //           setImage={(image) => setInputImage({image})}
    //           tagArray={collectionContext.tags}
    //           dbTable={db.images}
    //           refreshTags={fetchTags}
    //           isMyCollection={false}
    //           regenerateImage={handleGenerate}
    //           viewFailedImage={failedImageViewing}  
    //         />
    //       </div>
    //     );
    //   };

    const fetchTags = async () => {
        const tempSet = new Set();
        await db.images.each(record => {
            if (record.tag) {
              record.tag.split(",").forEach(tag => {
                if (tag) {
                  tempSet.add(tag.trim());
                }
              });
            } else {
              setEmpty(true);
            }
        });

        let uniqueArray = [];
        let lowercasedArray = [];
        
        Array.from(tempSet).forEach(value => {
            if (!lowercasedArray.includes(value.toLowerCase())) {
                uniqueArray.push(value);
                lowercasedArray.push(value.toLowerCase());
            }
        });

        lowercasedArray = null;
        
        setCategories(uniqueArray.sort((a, b) => a.localeCompare(b)));
        collectionContextDispatch({type: 'tagging', tags: uniqueArray});
    }

    useEffect(() =>{
        fetchTags();
    },[imageList])

    useEffect(() => {
        if (generateStatus.status === "loading") {
            // Workaround for batches not returning 100 progress when images are done.
            if (generateStatus.count > 0) {
                if (generateStatus.count === generateStatus.totalImages) {
                    console.log('Stopping with enough images', `${generateStatus.totalImages} of ${generateStatus.count}`);
                    generateStatusDispatch({type: 'done'});
                    setStartTimer(false);
                    setSeconds(0);
                }
            }
        }
    }, [generateStatus.count, generateStatus.totalImages])

    useEffect(() => {
        if (generateStatus.status === "generating") {
            // make sure the reducer is in the right mode and then start fetching the job
            if (generateStatus.uid.length > 0 && !generateStatus.intervalId) {
                const fetchTimeout = setTimeout(fetchJob, 2500);
                generateStatusDispatch({type: 'loading', intervalId: fetchTimeout});
            }
        }
        if (generateStatus.status === "loading") {
            // Workaround for batches not returning 100 progress when images are done.
            if (generateStatus.count > 0) {
                if (generateStatus.count === generateStatus.totalImages && generateStatus.progress === 0) {
                    console.log('Stopping with enough images', `${generateStatus.totalImages} of ${generateStatus.count}`);
                    generateStatusDispatch({type: 'done'});
                    setStartTimer(false);
                    setSeconds(0);
                }
            }
        }
        if (generateStatus.status === "done") {
            getTotalStoredImages();
        }
    }, [generateStatus.status])

    /**
     * Handle the cancel button
     * @returns {Promise<*>}
     */

    const doCancelJob = async () => {
        if (generateStatus.uid) {
            localStorage.setItem('isCancelling', true);
            generateStatusDispatch({type: 'cancel'});
            if (generateStatus.intervalId) {
                clearTimeout(generateStatus.intervalId);
            }
            setStartTimer(false);
            setSeconds(0);
            return cancelJob(generateStatus.uid, account.accountNo, apiState, generateStatusDispatch).then(async() => {
                generateStatusDispatch({type: 'ready'});
                refreshImages();
                localStorage.setItem('remember_workload', JSON.stringify({
                    active: false,
                    uid: "",
                    count: 0,
                    totalImage: 0,
                    num: 0,
                }))
            });
        }
    }

    let num = 0;

    const handleFailedImage = async (uid) => {
        console.log("Handling Failed Image | Count: ", generateStatus.count, " | TotalImages: ", generateStatus.totalImages, " | Num: ", num);
        let remainingImages;
        let totImagesMath = generateStatus.count - generateStatus.totalImages;
        let numImagesMath = generateStatus.count - num;
        if (totImagesMath < numImagesMath) {
            console.log("Total Images: ", totImagesMath);
            remainingImages = totImagesMath;
        } else if (numImagesMath < totImagesMath) {
            console.log("Num Images: ", numImagesMath);
            remainingImages = numImagesMath;
        } else {
            remainingImages = numImagesMath;
        }    
        console.log("Remaining Images: ", remainingImages);
        
        for (let i = 0; i < remainingImages; i++) {
            let randomNum = Math.floor(Math.random() * 99999999);
            let hashed = md5(randomNum.toString());
            let image = '';
            await db.images.put({
                image,
                seed: '',
                uid: uid,
                model: '',
                inCollection: false,
                hash: hashed,
                online: apiState.online,
                tag: generateStatus.tag,
                requestedtimestamp: Date.now(),
                receivedtimestamp: Date.now()
            })       
            // .then(() => {
            //     getTotalStoredImages();
            // })
        }
        getTotalStoredImages();
    }

    useEffect(() => {
        if (!startTimer) return;
    
        const timer = setInterval(() => {
          setSeconds(prevSeconds => prevSeconds + 1);
        }, 1000);
    
        console.log("Seconds: ", seconds);

        if (seconds === 90) {
          clearInterval(timer);
          console.log("A minute and a half has passed, timing out the job");
          if (!failedImage) {
            if (generateStatus.uid) {
                handleFailedImage(generateStatus.uid);
                // generateStatusDispatch({ type: 'error', message: "Job Timed Out" });
                setStartTimer(false);
                setSeconds(0);
                doCancelJob();
            }
          }
        }
    
        return () => clearInterval(timer);
      }, [startTimer, seconds]);
    
    let jobProgression = 0;
    const fetchJob = async () => {
        if (localStorage.getItem('isCancelling') === 'true') {
            console.log("Job cancelled. Skipping fetch.");
            return;
        }

        if (isFetching) return;

        setIsFetching(true);
        if (apiState.online == true) {
            setStartTimer(true);
        }
        let uid = "";
        let GenerationError = false;
        let tokenAmount = 0;
        let tempArr = [];
        let onlineTempArr = [];
    
        if (!uid) {
            if (generateStatus.uid) {
                uid = generateStatus.uid;
            }
        }
    
        let playSounds;
        await db.settings.where('key').equals('play_sounds').first(setting => {
            playSounds = setting.value;
        });
        console.log("Fetching job data for: ", uid);
        if (uid) {
            getProgress(uid, apiState, generateStatusDispatch)
                .then(async data => {
                    if (apiState.online == true) {
                        setStartTimer(true);
                    }
                    if (jobProgression !== data.progress) {
                        jobProgression = data.progress;
                        setSeconds(0);
                    }

                    console.log(jobProgression);
                    console.log("Fetching progress data: ", data);
                    console.log("error ", data.error);
                    console.log("data.output ", data.output);

                    if (data.progress > 0) {
                        generateStatusDispatch({ type: 'progress', progress: data.progress });
                    }
                    // Check if there's an error and return
                    if (Number(data.progress) === 100 && data.error !== undefined && data.error !== "None") {
                        console.log("Error in data: ", data.error);
                        if (!failedImage) {
                            handleFailedImage(uid);
                        }
                        generateStatusDispatch({ type: 'error', message: data.error });
                        setIsFetching(false);
                        GenerationError = true;
                        setStartTimer(false);
                        setSeconds(0);
                        return;
                    }

                    // Process each element in the output array
                    if (data && data.output && Array.isArray(data.output)) {
                        await Promise.all(
                            data.output.map(async(item) => {
                                const outputUid = item.uid;
                                console.log("Image id from getProgress", outputUid);
        
                                if (outputUid) {
                                    try {
                                        const hashcheck = await db.images.where('hash').equals(outputUid).first();
                                        if (!hashcheck) {
                                            const image = await getGenerateOutput(uid, outputUid);
                                            console.log("IMAGE", image);
        
                                            if (image) {
                                                if (failedImage === false) {
                                                    await db.images.put({
                                                        image: image.image,
                                                        seed: image.seed,
                                                        uid: uid,
                                                        model: image.model ?? '',
                                                        inCollection: false,
                                                        hash: outputUid,
                                                        online: apiState.online,
                                                        tag: generateStatus.tag,
                                                        prompt: image.prompt,
                                                        receivedtimestamp: Date.now(),
                                                        requestedtimestamp: Date.now()
                                                    })
                                                        .then(() => {
                                                            setReceived(uid, outputUid);
                                                            num += 1;
                                                            refreshImages();
                                                            generateStatusDispatch({
                                                                type: 'imageProgress',
                                                                setting: playSounds
                                                            });
                                                            tempArr.push(image);
                                                            setUnfinished(tempArr);
                                                        })
                                                        .catch(e => {
                                                            if (!failedImage) {
                                                                handleFailedImage(uid);
                                                            }
                                                            console.error('Error while adding images:', e);
                                                            console.error('Error stack trace:', e.stack);
                                                            console.error("Inner Exception: ", e.inner);
                                                            console.error('Error message:', e.message);
                                                            if (e.name !== "ConstraintError") {
                                                                console.error(e);
                                                                generateStatusDispatch({
                                                                    type: 'error',
                                                                    message: `An error occurred adding images. ${e.name}`
                                                                });
                                                            }
                                                            if (e.name === "ConstraintError") {
                                                                console.error(e);
                                                                generateStatusDispatch({
                                                                    type: 'error',
                                                                    message: `An error occurred adding images. ${e.name}`
                                                                });
                                                            }
                                                            generateStatusDispatch({
                                                                type: 'error',
                                                                message: `An error occurred adding images. ${e.name}`
                                                            });
                                                            console.log("Error caught and cancelling job");
                                                            GenerationError = true;
                                                            setStartTimer(false);
                                                            setSeconds(0);
                                                            // doCancelJob();
                                                        })
                                                        .finally(async () => {
                                                            console.log("Prompt in data: ", image.prompt);
                                                            if (+data.progress === 100 && (["ready"].indexOf(generateStatus.status) !== -1 || data.error === "None" || generateStatus.count === generateStatus.totalImages)) {
                                                                console.log("Images completed");
                                                                // update the prompt
                                                                const items = await db.collection.where('uid').equals(generateStatus.uid).toArray();
                                                                if (items.length > 0) {
                                                                    let oldPrompt = items[0].prompt;
                                                                    oldPrompt.prompt.prompt = image.prompt;
                                                                    await db.collection.update(items[0].id, { prompt: oldPrompt });
                                                                }
                                                                setPage(0);
                                                                populateHistory();
                                                                generateStatusDispatch({ type: 'done' });
                                                            }
                                                            getTokens(accountContext.accountDetails.accountNo).then(data => {
                                                                accountContextDispatch({type : "tokens", tokens: data.credits})
                                                            })
                                                            setStartTimer(false);
                                                            setSeconds(0);
                                                        });
                                                } else if (failedImage === true) {
                                                    let results;
                                                    let imageID;
                                                    console.log("************* FAILED *************" + generateStatus);
                                                    if (generateStatus.failedWorkloadUID !== null) {
                                                        console.log("Failed workload regeneration: ", generateStatus.failedWorkloadUID);
                                                        results = await db.images.where('uid').equals(generateStatus.failedWorkloadUID).and(item => item.image === '').toArray();
                                                        imageID = results[0].id;
                                                    } else {
                                                        console.log("Failed image regeneration", failedImageID);
                                                        imageID = failedImageID;
                                                    }
                                                    console.log("This is the regenerated image: ", image);
                                                    
                                                    await db.images.update(imageID, {
                                                        image: image.image,
                                                        seed: image.seed,
                                                        model: image.model ?? '',
                                                        hash: outputUid,
                                                        prompt: image.prompt,
                                                        receivedtimestamp: Date.now()
                                                    })
                                                        .then(() => {
                                                            setReceived(uid, outputUid);
                                                            num += 1
                                                            console.log("Image updated");
                                                            generateStatusDispatch({ type: 'imageProgress', setting: playSounds });
                                                            refreshImages();
                                                        })
                                                        .finally(async () => {
                                                            console.log("Image finished updating");
                                                            imageID = null;
                                                            results = null;
                                                            if (+data.progress === 100 && (["ready"].indexOf(generateStatus.status) !== -1 || data.error === "None" || generateStatus.count === generateStatus.totalImages)) {
                                                                // update the prompt
                                                                const items = await db.collection.where('uid').equals(generateStatus.uid).toArray();
                                                                if (items.length > 0) {
                                                                    let oldPrompt = items[0].prompt;
                                                                    oldPrompt.prompt.prompt = image.prompt;
                                                                    await db.collection.update(items[0].id, { prompt: oldPrompt });
                                                                }
                                                                setPage(0);
                                                                populateHistory();
                                                                setFailedImage(false);
                                                                generateStatusDispatch({ type: 'done' });
                                                                setStartTimer(false);
                                                                setSeconds(0);
                                                            }
                                                            getTokens(accountContext.accountDetails.accountNo).then(data => {
                                                                accountContextDispatch({type : "tokens", tokens: data.credits})
                                                            })
                                                        });
                                                }
                                            }
                                        }
                                    } catch (error) {
                                        console.error("Error in processing:", error);
                                        GenerationError = true;
                                        setStartTimer(false);
                                        setSeconds(0);
                                    }
                                }

                            })
                        )
                        // for (const item of data.output) {
                        // }
                    } else if (apiState.online == false && data.prompt) {
                        console.log("Offline ==============================");
                        console.log("PROMPT DATA: ", data);
                        console.log("PROMPT DATA OUTPUT: ", data.prompt.output);
                        let generatedImages = [];
                        if (data.prompt.output) {
                            const { images, seeds, models } = data.prompt.output;
                            if (images) {
                                await Promise.all(
                                    images.map(async(image) =>{
                                        const i = images.indexOf(image);
                                        console.log("Length of the images: ", images.length);
                                        let md5_hash;
                                        if (sameSeed) {
                                            md5_hash = md5(image + "PROMPTUS" + sameSeedDate.toString() + images.length.toString());
                                        } else {
                                            md5_hash = md5(image);
                                        }
                                        const hashcheck = await db.images.where('hash').equals(md5_hash).first();
                                        if (!hashcheck) {
                                            if (failedImage === false) {
                                                await db.images.put({
                                                    image,
                                                    seed: seeds[i],
                                                    uid: uid,
                                                    model: models[i] ?? '',
                                                    inCollection: false,
                                                    hash: md5_hash,
                                                    online: apiState.online,
                                                    tag: generateStatus.tag,
                                                    prompt: data.prompt.prompt,
                                                    receivedtimestamp: Date.now(),
                                                    requestedtimestamp: Date.now()
                                                })
                                                    .then(() => {
                                                        num += 1;
                                                        console.log("Image added with the num being: ", num);
                                                        refreshImages();
                                                        console.log("Image added to the database");
                                                        generateStatusDispatch({ type: 'imageProgress', setting: playSounds });
                                                        tempArr.push(image);
                                                        setUnfinished(tempArr);
                                                    })
                                                    .catch(e => {
                                                        if (!failedImage) {
                                                            handleFailedImage(uid);
                                                        }
                                                        console.error('Error while adding images:', e);
                                                        console.error('Error stack trace:', e.stack);
                                                        console.error("Inner Exception: ", e.inner);
                                                        console.error('Error message:', e.message);
                                                        if (e.name !== "ConstraintError") {
                                                            console.error(e);
                                                            generateStatusDispatch({ type: 'error', message: `An error occurred adding images. ${e.name}` });
                                                        }
                                                        if (e.name === "ConstraintError") {
                                                            console.error(e);
                                                            generateStatusDispatch({ type: 'error', message: `An error occurred adding images. ${e.name}` });
                                                        }
                                                        generateStatusDispatch({ type: 'error', message: `An error occurred adding images. ${e.name}` });
                                                        console.log("Error caught and cancelling job");
                                                        // doCancelJob();
                                                        GenerationError = true;
                                                        setStartTimer(false);
                                                        setSeconds(0);
                                                    })
                                                    .finally(() => {
                                                        console.log("------------Data: ", data, "Generate Status: ", generateStatus);
                                                        if (+data.progress === 100 && (["ready"].indexOf(generateStatus.status) !== -1 || data.error === "None" || generateStatus.count === generateStatus.totalImages)) {
                                                            console.log("Inside------------Data: ", data, "Generate Status: ", generateStatus);
                                                            // update the prompt
                                                            db.collection.where('uid').equals(generateStatus.uid).toArray(items => {
                                                                if (items.length > 0) {
                                                                    let oldPrompt = items[0].prompt;
                                                                    oldPrompt.prompt.prompt = data.prompt.prompt;
                                                                    db.collection.update(items[0].id, { prompt: oldPrompt });
                                                                }
                                                            });
                                                            setPage(0);
                                                            populateHistory();
                                                            generateStatusDispatch({ type: 'done' });
                                                            setSameSeedDate(0);
                                                        }
                                                        setStartTimer(false);
                                                        setSeconds(0);
                                                    });
            
                                            } else if (failedImage === true) {
                                                let results;
                                                let imageID;
                                                
                                                if (generateStatus.failedWorkloadUID !== null) {
                                                    console.log("Failed workload regeneration: ", generateStatus.failedWorkloadUID);
                                                    results = await db.images.where('uid').equals(generateStatus.failedWorkloadUID).and(item => item.image === '').toArray();
                                                    imageID = results[0].id;
                                                } else {
                                                    console.log("Failed image regeneration", failedImageID);
                                                    imageID = failedImageID;
                                                }
                                                await db.images.update(imageID, { image: image, seed: seeds[i], model: models[i] ?? '', hash: md5_hash, prompt: data.prompt.prompt, receivedtimestamp: Date.now() })
                                                    .then(() => {
                                                        num += 1;
                                                        console.log("Image updated");
                                                        generateStatusDispatch({ type: 'imageProgress', setting: playSounds });
                                                        refreshImages();
                                                    })
                                                    .finally(() => {
                                                        console.log("Image finished updating");
                                                        imageID = null;
                                                        results = null;
                                                        if (+data.progress === 100 && (["ready"].indexOf(generateStatus.status) !== -1 || data.error === "None" || generateStatus.count === generateStatus.totalImages)) {
                                                            // update the prompt
                                                            db.collection.where('uid').equals(generateStatus.uid).toArray(items => {
                                                                if (items.length > 0) {
                                                                    let oldPrompt = items[0].prompt;
                                                                    oldPrompt.prompt.prompt = data.prompt.prompt;
                                                                    db.collection.update(items[0].id, { prompt: oldPrompt });
                                                                }
                                                            });
                                                            setPage(0);
                                                            populateHistory();
                                                            setFailedImage(false);
                                                            generateStatusDispatch({ type: 'done' });
                                                        }
                                                        setStartTimer(false);
                                                        setSeconds(0);
                                                    });
                                            }
                                        }

                                    })
                                )
                                // for (const image of images) {
                                // }
                            }
                        }
                        
                    }
                }).catch(error => {
                if (!failedImage) {
                    handleFailedImage(uid);
                }
                console.error('Error occurred fetching the generation progress:', error);
                console.error('Error stack trace:', error.stack);
                console.error("Inner Exception: ", error.inner);
                console.error('Error message:', error.message);
                generateStatusDispatch({
                    type: 'error',
                    message: "An error occurred fetching the generation progress"
                });
                GenerationError = true;
                setStartTimer(false);
                setSeconds(0);
            })
            .finally(() => {
                setIsFetching(false);
                if (localStorage.getItem('isCancelling') === 'false' && generateStatus.status === "generating" && generateStatus.count !== num && num < generateStatus.count && !GenerationError) {
                    console.log(":==================:", generateStatus, "num: ", num);
                    const fetchTimeout = setTimeout(fetchJob, 2500);
                    generateStatusDispatch({type: 'loading', intervalId: fetchTimeout});
                }
            });
        } else {
            setIsFetching(false);
            if (localStorage.getItem('isCancelling') === 'false' && generateStatus.status === "generating" && generateStatus.count !== num && num < generateStatus.count && !GenerationError) {
                console.log(":==================:", generateStatus);
                const fetchTimeout = setTimeout(fetchJob, 2500);
                generateStatusDispatch({type: 'loading', intervalId: fetchTimeout});
            }
        }

    };
    

    /**
     * Clears the generated image collection
     * @returns {Promise<void>}
     */
    const doClearGenerated = async () => {
        Swal.fire({
            color: "#190A4E",
            title: `Clear all generated images under the selected filter: ${category}, this cannot be undone?`,
            icon: "info",
            confirmButtonText: 'Confirm',
            confirmButtonColor: "#FFB02E",
            showDenyButton: true,
            denyButtonText: "Cancel",
            denyButtonColor: "#190A4E",
        }).then(async(result) => {
            if (result.isConfirmed) {
                try {
                    console.log("Category: ", category);
                    let keysToDelete;
                    if (category === "All") {
                        await db.transaction('rw', db.images, async () => {
                            await db.images.clear();
                            getTotalStoredImages();
                        });   
                    } else if (category === "Failed") {
                        keysToDelete = await db.images.filter(image => image.image == "").primaryKeys();
                    } else {
                        keysToDelete = await db.images.filter(image => !isUndefined(image.tag) && image.tag.toLowerCase().includes(category.toLowerCase())).primaryKeys();
                    }
                    console.log("Keys to delete: ", keysToDelete);
                    if (keysToDelete.length > 0) {
                        await db.images.bulkDelete(keysToDelete);
                        console.log(`${keysToDelete.length} records deleted.`);
                        setCategory("All");
                      } else {
                        console.log('No records found with the specified value.');
                      }
                } catch (error) {
                    console.error("Error clearing images: ", error);
                }
            }
        })
    }

    useEffect(() => {
        populateHistory();
        getTotalStoredImages();
    }, []);

    useEffect(() => {
        refreshImages();
    }, [page, showAll, category, sortMethod]);

    const getNumColumns = () => {
        switch(columnClass) {
            case "cols-1":
                return "grid-cols-1 md:grid-cols-1 lg:grid-cols-1";
            case "cols-2":
                return "grid-cols-2 md:grid-cols-2 lg:grid-cols-2";
            case "cols-3":
                return "grid-cols-1 md:grid-cols-3 lg:grid-cols-3";
            default:
            case "cols-4":
                return "grid-cols-1 md:grid-cols-4 lg:grid-cols-4";
            case "cols-5":
                return "grid-cols-1 md:grid-cols-5 lg:grid-cols-5";
            case "cols-6":
                return "grid-cols-1 md:grid-cols-6 lg:grid-cols-6";
        }
    }

    const handleEscapeKey = (e) => {
        console.log("Key pressed: ", e);
        
        if (e.key === "Escape") {
            setZoomedImage(null)
        }
    }

    useEffect(() => {
        if (zoomedImage) {
            window.addEventListener('keydown', handleEscapeKey);
        }

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('keydown', handleEscapeKey);
        };
    }, [zoomedImage]);

    const failedImageViewing = async (imageDetails) => {
        console.log("Failed image viewing", imageDetails);
        if (typeof imageDetails === 'string') {
            const hashfailedDetailed = await db.images.where('hash').equals(imageDetails).first();
            setFailedImageDetails(hashfailedDetailed);
        } else {
            setFailedImageDetails(imageDetails);
        }    
        setViewFailedImage(!viewFailedImage);
    }
    const handleRedos = (hash, seed, uid) => {
        if (hash !== null && seed == null && uid == null) {
            console.log("Redo | hash: ", hash);
            
            setRedoPrompt(hash);
            setRedoSeed("");
            setRedoPromptUid("");
        } else if (hash == null && seed !== null && uid == null) {
            console.log("Redo | Seed: ", seed);
            
            setRedoPrompt("");
            setRedoSeed(seed);
            setRedoPromptUid("");
        } else if (hash == null && seed == null && uid !== null) {
            console.log("Redo | UID: ", uid);
            
            setRedoPrompt("");
            setRedoSeed("");
            setRedoPromptUid(uid);
        }  
    }

    return (
        <>
            <PromptHeader
                defaultPrompt={defaultPrompt}
                handleGenerate={handleGenerate}
                cancelPrompt={doCancelJob}
                uid={redoPromptUid}
                prompt={redoPrompt}
                seed={redoSeed}
                inputImage={inputImage}
                pageNumber={setPage}
                setCategory={setCategory}
                fetchingUndelivered={fetchingUndelivered}
            />
            {totalStoredImages === 0 && !generateStatus.loading ? (
                    <>
                        <p className={"text-2xl text-center"}>Get started by entering a prompt.</p>
                    </>) :
                <div className={"px-4 relative mb-5 w-full"}>
                    <h2 className={"text-xl px-2 font-bold flex flex-row items-center"}>
                        <span>Results</span>
                        <hr className={"mx-2 flex-grow border border-white/40 bg-white/40"} />
                        <select className={"rounded-lg text-dark-blue border-0 p-2 me-1"} value={sortMethod} onChange={(e) => setSortMethod(e.target.value)}>
                            <option value="Newest">From Newest</option>
                            <option value="Oldest">From Oldest</option>
                            <option value="New_requested">Ordey By Latest Requested</option>
                            <option value="Old_requested">Ordey By Oldest Requested</option>
                            {empty ? 
                                <>
                                    <option value={"Non-Tagged-Asc"}>Non-Tagged - New to Old</option>
                                    <option value={"Non-Tagged-Desc"}>Non-Tagged - Old To New</option>
                                </>
                            :
                                null    
                            }
                            <option value={"AIHorde-Images-Asc"}>AI-Horde Images - New to Old</option>
                            <option value={"AIHorde-Images-Desc"}>AI-Horde Images - Old to New</option>
                        </select>
                        <select className={"rounded-lg text-dark-blue border-0 p-2 me-1"} slot='5' value={category} onChange={(e) => setCategory(e.target.value)}>
                            <option value={"All"}>All</option>
                            <option value={"Failed"}>Regen Images</option>
                            {categories.map((category, i) => <option value={`${category}`}>{category.charAt(0).toUpperCase() + category.slice(1).toLowerCase()}</option>)}
                        </select>
                        <button className={"py-2 px-4 mx-1 border rounded bg-red-400 transition"} onClick={doClearGenerated}>Delete All</button>
                        <div className={"flex flex-row justify-end items-center lg:p-4"}>
                            {!showAll ?
                                <>
                                    {page > 0 ?
                                        <button className={"text-4xl p-2"} onClick={() => setPage(page - 1)}>
                                            <img src={DoubleLeftIcon} alt="Previous Page" className='h-10'/>
                                        </button> 
                                        : 
                                        <button className={"text-4xl p-2 text-gray-400"} >
                                            <img src={GreyDoubleLeftIcon} alt="Previous Page" className='h-10'/>
                                        </button>}
                                    <div className={"text-xl p-2"} >{page + 1}</div>
                                    {(page * 20 + 20) < totalStoredImages ?
                                        <button className={"text-4xl p-2"} onClick={() => setPage(page + 1)}>
                                            <img src={DoubleRightIcon} alt="Next Page" className='h-10'/>
                                        </button> 
                                        :  
                                        <button className={"text-4xl p-2 text-gray-400"} >
                                            <img src={GreyDoubleRightIcon} alt="Next Page" className='h-10'/>
                                        </button>}
                                </>
                                    : 
                                null}
                            <button className={"py-2 px-4 mx-1 border rounded hover:bg-dark-blue transition md:py-1 md:mb-2"} onClick={() => setShowAll(!showAll)}>Show {showAll ? "Pages" : "All"}</button>
                            <span className={"font-light mr-5 text-sm"}>Images: <span className={"font-bold"}>{totalStoredImages}</span></span>
                            <select className={"rounded-lg text-dark-blue border-0 p-2"}
                                    value={columnClass} onChange={(e) => setColumnClass(e.target.value)}>
                                <option value={"cols-2"}>2 Columns</option>
                                <option value={"cols-3"}>3 Columns</option>
                                <option value={"cols-4"}>4 Columns</option>
                                <option value={"cols-5"}>5 Columns</option>
                                <option value={"cols-6"}>6 Columns</option>
                            </select>
                        </div>
                    </h2>
                    <div className={`grid ${getNumColumns()} gap-4 imageCollection`}>
                        {generateStatus.loading && !generateStatus.failedImage ? 
                            <Placeholder Count={generateStatus.count - generateStatus.totalImages}></Placeholder>
                        : null
                        }
                        {imageList.map((image, i) => (
                        <LazyLoad key={`image_${i}_${image.id}`} height={2} offset={200} placeholder={<Placeholder Count={1}></Placeholder>}>
                            <CollectionImage
                                {...image}
                                key={`image_${i}_${image.id}`}
                                refreshImages={getTotalStoredImages}
                                setZoomedImage={(image) => setZoomedImage(image)}
                                setUid={(uid) => handleRedos(null,null,uid)}
                                setPrompt={(hash) => handleRedos(hash,null,null)}
                                setSeed={(seed) => handleRedos(null,seed,null)}
                                setImage={(image) => setInputImage({image})}
                                tagArray={collectionContext.tags}
                                dbTable={db.images}
                                refreshTags={fetchTags}
                                isMyCollection={false}
                                regenerateImage={handleGenerate}
                                viewFailedImage={failedImageViewing}  
                            />
                        </LazyLoad>    
                        ))}
                    </div>
                        {/* <AutoSizer>
                            {({ height, width }) => {
                                // Calculate columnCount and adjusted sizes
                                const minColumnWidth = 200; // Desired minimum column width
                                const totalGap = gap;
                                const columnCount = 4;
                                const adjustedColumnWidth = width / columnCount - totalGap;
                                const aspectRatio = 1; // Adjust based on your images
                                const adjustedRowHeight = adjustedColumnWidth * aspectRatio + gap;
                                const rowCount = Math.ceil(imageList.length / columnCount);

                                // onItemsRendered callback
                                const onItemsRendered = ({ visibleRowStopIndex }) => {
                                const visibleItemsCount = (visibleRowStopIndex + 1) * columnCount;
                                const threshold = imageList.length - columnCount * 2;

                                if (visibleItemsCount >= threshold) {
                                    console.log("Visible items count: ", visibleItemsCount);
                                }
                                };

                                return (
                                <Grid
                                    columnCount={columnCount}
                                    columnWidth={() => adjustedColumnWidth + gap}
                                    height={height}
                                    rowCount={rowCount}
                                    rowHeight={() => adjustedRowHeight}
                                    width={width}
                                    onItemsRendered={onItemsRendered}
                                    itemData={{ imageList, columnCount, gap }}
                                >
                                    {Cell}
                                </Grid>
                                );
                            }}
                        </AutoSizer> */}
                    {zoomedImage ?
                        <div className={"fixed top-0 left-0 z-10 flex flex-col justify-center place-items-center h-screen w-screen bg-dark-blue/40 backdrop-blur"}>
                            <div className={"w-full mx-auto max-w-screen-lg bg-gray-500/50 flex flex-row justify-end"} onKeyDown={(e) => handleEscapeKey(e)}>
                                <button className={"px-5 py-2 rounded bg-dark-blue text-white m-2 hover:text-yellow transition"} onClick={() => setZoomedImage(null)}>
                                    <img src={CloseIcon} alt='Close Image' className='h-7'/>
                                </button>
                            </div>
                            {/*<div className={"relative w-full max-w-screen-lg"}>*/}
                            {/*    <button className={"absolute top-0 right-0 px-5 py-2 bg-dark-blue/40 rounded-lg hover:bg-dark-blue transition"} type={"button"}>Close</button>*/}
                            {/*    <img className={"w-full rounded-lg"} src={`data:image/webp;base64,${ zoomedImage.image }`} alt={`Generated image: ${ zoomedImage.seed }`} />*/}
                            {/*</div>*/}
                            <DrawingInput image={`data:image/webp;base64,${ zoomedImage.image }`} setImage={(image) => setInputImage({image})} closeEvent={() => setZoomedImage(null)}/>
                        </div>
                        : null}
                </div>
            }
            <div className={`flex flex-col w-96 bg-dark-blue h-full fixed z-50 top-0 right-0 ${viewFailedImage ? 'block' :'hidden'}`}>
                <div className='h-16 border-b flex flex-row justify-between items-center'>
                    <p className='text-lg font-medium ml-3 text-yellow'>Image Details: </p>
                    <button className={"w-12 h-12 p-1 mr-3"} title="Close Image Details" onClick={() => setViewFailedImage(false)}>
                        <img src={CloseIcon} alt='Close Image' className='h-7'/>
                    </button>
                </div>
                {viewFailedImage ?
                    <div className='mt-5 px-3'>
                        <p className='font-semibold text-lg text-yellow'>Prompt: <span className='text-white'>{failedImageDetails.prompt ?? ''}</span></p>
                        <p className='font-semibold text-lg text-yellow'>Negative Prompt: <span className='text-white'>{failedImageDetails.negative_prompt ?? ''}</span></p>
                        <p className='font-semibold text-lg text-yellow'>Seed: <span className='text-white'>{failedImageDetails.params?.seed_value ?? failedImageDetails.seed}</span></p>
                        <p className='font-semibold text-lg text-yellow'>Steps: <span className='text-white'>{failedImageDetails.params?.num_inference_steps ?? ''}</span></p>
                        <p className='font-semibold text-lg text-yellow'>Guidance: <span className='text-white'>{failedImageDetails.params?.guidance_scale ?? ''}</span></p>
                        <p className='font-semibold text-lg text-yellow'>Model: <span className='text-white'>{failedImageDetails.params?.model ?? failedImageDetails.model}</span></p>
                        <p className='font-semibold text-lg text-yellow'>Height x Width: <span className='text-white'>{`${failedImageDetails.params?.height ?? ''}x${failedImageDetails.params?.width ?? ''}`}</span></p>
                        <p className='font-semibold text-lg text-yellow'>Scheduler: <span className='text-white'>{failedImageDetails.params?.scheduler ?? ''}</span></p>
                        <p className='font-semibold text-lg text-yellow'>Lora: <span className='text-white'>{failedImageDetails.params?.lora ?? ''}</span></p>
                        <p className='font-semibold text-lg text-yellow'>Lora Scale: <span className='text-white'>{failedImageDetails.params?.lora_scale ?? ''}</span></p>
                        <p className='font-semibold text-lg text-yellow'>Count: <span className='text-white'>{failedImageDetails.params?.count ?? ''}</span></p>
                        <p className='font-semibold text-lg text-yellow'>Image Batch Size: <span className='text-white'>{failedImageDetails.params?.image_batch_size ?? ''}</span></p>
                        <p className='font-semibold text-lg text-yellow'>Control Net: <span className='text-white'>{failedImageDetails.params?.control_net ?? ''}</span></p>
                    </div>
                :
                    null
                }
            </div>
        </>
    );
}
